/**
 * Profile photo upload rules (#579), read by both sides: the backend enforces
 * them, the Account settings picker filters on them so a refusal is rare.
 */

/** Largest file accepted, in bytes (5 MB). The photo is stored as a 200 px WebP. */
export const AVATAR_MAX_BYTES = 5 * 1024 * 1024;

/** Accepted image types. The backend re-checks the decoded format, not only this. */
export const AVATAR_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const;
